<template>
  <div id="train_search_result_dialog_outer">
    <div v-if="itemList.length > 0">
      <a v-if="loadClose" class="iconfont close-button" href="javascript:void(null);"
         @click="$emit('close')">&#xe639;</a>
      <div class="content">

        <div v-if="loadClose" class="name" style="font-size:1.5rem;color: #fc1a34;">恭喜&nbsp;<b>{{userList[0].name}}</b>&nbsp;成功通过本次测试！</div>
        <div v-if="loadClose" class="cer-image" v-for="(item, index) in itemList" :key="'cert_image_' + index">
          <el-image :src="item.certImage" fit="contain" style="margin-top: 15px;"></el-image>
<!--          <div>nihao</div>-->
          <div style="margin-top: 12px;">
            <!--          <a href="#" target="_blank" ><span class="iconfont" style="margin-right: 5px;">&#xe63f;</span>名单公示</a>-->
            <!--          href="https://img.shslqxh.com/上海市篮球协会章程202010.pdf" target="_blank" class="organization-download" download="上海市篮球协会章程202010.pdf"-->
            <a v-if="showDownloadButton" :href="item.certImage" download="我的证书.png" ><span class="iconfont" style="margin-right: 5px;">&#xe617;</span>下载高清版</a>
            <span style="font-weight: normal;color: #333;" v-else >长按上方图片保存证书</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Loading} from "element-ui";
export default {
  name: "TrainSearchResultDialog",
  props: [
    'user',
    'userList',
  ],
  data() {
    return {
      certImage: null,
      itemList: [],
      count: 0,
      loadClose: false,

      showDownloadButton: false,
    }
  },

  mounted() {

    this.showDownloadButton = !this.isMobile();
    let userList= this.userList;
    if (userList == undefined || userList == null || userList.length == 0) {
      return;
    }

    let _this = this;
    this.count = userList.length;
    let loadFlags = Loading.service({
      target: document.getElementById('app'),
      fullscreen: true
    });
    for (let i = 0; i < userList.length; i++) {
      let item = userList[i];
      this.itemList.push(item);
      this.drawBasketballTrainingCertificateImage(item, function (image) {


        _this.itemList[i].certImage = image;
        _this.count -= 1;
        if (_this.count == 0) {
          _this.loadClose = true;
          loadFlags.close();
        }
      });

    }

    let user = this.user;
    if (user == null || user == undefined) {
      return;
    }
  },
  methods: {

  }
}
</script>

<style scoped>
  #train_search_result_dialog_outer {
    background-color: rgba(0,0,0,0.3);
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
  }

  #train_search_result_dialog_outer > div {
    position: relative;
    max-width: 1200px;
    height: auto;
    max-height: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
    background-color: white;
    overflow-y: auto;
  }

  #train_search_result_dialog_outer > div .content {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
  }

  #train_search_result_dialog_outer .close-button {
    position: absolute;
    top: 0;
    right: 3px;
    color: black;
    font-size: 2rem;
    text-decoration: none;
    z-index: 100;
  }

  #train_search_result_dialog_outer > div .cer-image {
    background-color: white;
    max-width: 100%;
  }

  #train_search_result_dialog_outer > div .cer-image .el-image {
    width: 100%;
    height: auto;
  }

  #train_search_result_dialog_outer > div .cer-image a {
    color: #333;
    font-weight: bold;
    text-decoration: none;
  }

  #train_search_result_dialog_outer > div .cer-image:not(:first-child) {
    margin-top: 30px;
  }

  #train_search_result_dialog_outer > div .cer-image > div a:hover {
    color: #fc1a34;
  }

  @media screen and (min-width: 768px){
    #train_search_result_dialog_outer > div .content {
      padding-left: 40px;
      padding-right: 40px;
    }

    #train_search_result_dialog_outer > div .cer-image .el-image {
      height: 72vh;
      width: auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/train/TrainSearchResultDialog.vue